import { Typography, makeStyles, CardMedia, Box } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    padding: "40px 24px 2px",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    fontSize: 30,
    color: theme.orange,
    marginTop: 30,
  },
  subtitle: {
    color: theme.red,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  titlePoint: {
    marginLeft: 10,
    marginTop: 60,
    width: 50,
    height: 50,
  },
}));

const SFDialogTitle = ({
  title,
  icon,
  onClose,
  disableClose,
  subtitle,
  ...other
}) => {
  const classes = useStyles();
  //const { onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Box className={classes.titleContainer}>
        <Typography className={classes.title}>{title}</Typography>
        {subtitle && (
          <Typography variant="caption" className={classes.subtitle}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {icon ? <CardMedia className={classes.titlePoint} image={icon} /> : null}

      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

export default SFDialogTitle;
